/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';
import { addUniqueById } from 'shared/lib/addUniqueById';

const initialState_container = [
    {
        id: '',
        il_air_import_hbl_id: '',
        alias: '',
        il_opus_vessel_id: '',
        volume: '',
        il_opus_volume_unit_id: '',
        weight: '',
        customs: 1,
        customs_hold: 1,
        customs_other: '',
        il_trade_partner_id: '',
        delivery_order: 1,
        deliver_order_link: '',
        proof: 1,
        proof_link: '',
        proof_date: null,
    },
];

const aimContainerUpdateSlice = createSlice({
    name: 'aimContainerUpdateForm',
    initialState: initialState_container,
    reducers: {
        setContainerFormData: (state, action) => {
            return action.payload;
        },
        addContainer: (state, action) => {
            addUniqueById(state, action.payload);
        },
        deleteContainer: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((container) => container.id !== idToDelete);
        },
        setContainerUpdateData: (state, action) => {
            const { id, newData } = action.payload;
            return state.map((item) => {
                if (item.id === id) {
                    return { ...item, ...newData };
                }
                return item;
            });
        },
    },
});

export const { setContainerFormData, addContainer, deleteContainer, setContainerUpdateData } =
    aimContainerUpdateSlice.actions;
export default aimContainerUpdateSlice.reducer;
